import React, { Component, useReducer } from 'react';
import {Collapse,Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'
import Background_Image from '../images/image_3.jpg'
import {AiFillEye, AiFillCalendar} from 'react-icons/ai'
import {BsPeopleFill} from 'react-icons/bs'
import {CgGym} from 'react-icons/cg'
import {GiKnifeFork} from 'react-icons/gi'
import {BiPackage, BiTimeFive, BiWallet} from 'react-icons/bi'
import {IoMdPeople} from 'react-icons/io'
import {FiMessageSquare} from 'react-icons/fi'
import {FaCalendarAlt, FaMoneyBill, FaUserCircle} from 'react-icons/fa'
import Overview from './overview'
import Clients from './clients'
import Workouts from './workouts'
import Nutrition from './nutrition'
import Programs from './programs'
import Packages from './packages'
import Trainers from './org_trainers'
import Scheduler from './scheduler'
import Calendar from './calendar'
import Messages from './messages'
import UserDashboard from './user_dashboard'
import Profile from './profile'
import AdminDashboard from './admin_dashboard'
import Wallet from './wallet'

  class Dashboard extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
      super(props);
      this.state = {
        current_render: 'overview',
        user_details: {},
        all_clients: [],
        on_mobile: false,
        menu_collapsed: false
      };

      this.HandleChange = (e) =>{
        this.setState({[e.target.name]: e.target.value});
      };

      this.ChangeRender = (selected_render) => {
        this.setState({current_render: selected_render})

        if (this.state.on_mobile == true){
          this.ToggleMenuCollapse()
        }
      }

      this.RenderSelection = () => {
        var render = this.state.current_render

        if(render=='overview'){
          return<Overview all_clients={this.state.all_clients}/>
        }else if(render=='clients'){
          return<Clients all_clients={this.state.all_clients}/>
        }else if(render=='workouts'){
          return<Workouts all_clients={this.state.all_clients}/>
        }else if(render=='nutrition'){
          return<Nutrition all_clients={this.state.all_clients}/>
        }else if(render=='programs'){
          return<Programs all_clients={this.state.all_clients}/>
        }else if(render=='packages'){
          return<Packages all_clients={this.state.all_clients}/>
        }else if(render=='trainers'){
          return<Trainers all_clients={this.state.all_clients}/>
        }else if(render=='scheduler'){
          return<Scheduler all_clients={this.state.all_clients}/>
        }else if(render=='calendar'){
          return<Calendar all_clients={this.state.all_clients}/>
        }else if(render=='messages'){
          return<Messages all_clients={this.state.all_clients}/>
        }else if(render=='profile'){
          return<Profile all_clients={this.state.all_clients}/>
        }else if(render=='admin_dashboard'){
          return<AdminDashboard user_details={this.state.user_details}/>
        }else if(render=='wallet'){
          return<Wallet/>
        }
      }

      this.AdminButton = () => {
        if(this.state.user_details.role == 'admin'){
          return<>
            <Row>
              <Col>
                <Button onClick={() => this.ChangeRender('admin_dashboard')} style={{textAlign: 'left', backgroundColor: 'inherit', color: 'inherit', border: 'none', width: '100%', color: '#ffffff'}}>
                  <BiTimeFive color='#ffffff'/> Admin Dashboard
                </Button>
              </Col>
            </Row>
            <br/>
          </>
        }else{
          return<>
          </>
        }
      }

      this.DashboardSelections = () => {
        var user_details = this.state.user_details
        return<>
          <Row>
            <Col>
              <br/>
              <img src={Backend_Url + 'media/' + user_details.image} style={{width: 'auto', maxWidth: '150px'}}/>
              <br/><br/>
              <h6 style={{color: '#ffffff'}}>
                {user_details.firstname} {user_details.lastname}
              </h6>
            </Col>
          </Row>
          <br/>
          <this.AdminButton/>
          <Row>
            <Col>
              <Button onClick={() => this.ChangeRender('overview')} style={{textAlign: 'left', backgroundColor: 'inherit', color: 'inherit', border: 'none', width: '100%', color: '#ffffff'}}>
                <AiFillEye color='#ffffff'/> Overview
              </Button>
            </Col>
          </Row>
          <br/>
          <Row>
            <Col>
              <Button onClick={() => this.ChangeRender('wallet')} style={{textAlign: 'left', backgroundColor: 'inherit', color: 'inherit', border: 'none', width: '100%', color: '#ffffff'}}>
                <BiWallet color='#ffffff'/> Wallet
              </Button>
            </Col>
          </Row>
          <br/>
          <Row>
            <Col>
              <Button onClick={() => this.ChangeRender('messages')} style={{textAlign: 'left', backgroundColor: 'inherit', color: 'inherit', border: 'none', width: '100%', color: '#ffffff'}}>
                <FiMessageSquare color='#ffffff'/> Messages
              </Button>
            </Col>
          </Row>
          <br/>
          <Row>
            <Col>
              <Button onClick={() => this.ChangeRender('profile')} style={{textAlign: 'left', backgroundColor: 'inherit', color: 'inherit', border: 'none', width: '100%', color: '#ffffff'}}>
                <FaUserCircle color='#ffffff'/> Profile
              </Button>
            </Col>
          </Row>
          <br/>
          <Row>
            <Col>
              <Button onClick={() => this.ChangeRender('clients')} style={{textAlign: 'left', backgroundColor: 'inherit', color: 'inherit', border: 'none', width: '100%', color: '#ffffff'}}>
                <BsPeopleFill color='#ffffff'/> Clients
              </Button>
            </Col>
          </Row>
          <br/>
          <Row>
            <Col>
              <Button onClick={() => this.ChangeRender('workouts')} style={{textAlign: 'left', backgroundColor: 'inherit', color: 'inherit', border: 'none', width: '100%', color: '#ffffff'}}>
                <CgGym color='#ffffff'/> Workouts
              </Button>
            </Col>
          </Row>
          <br/>
          <Row>
            <Col>
              <Button onClick={() => this.ChangeRender('nutrition')} style={{textAlign: 'left', backgroundColor: 'inherit', color: 'inherit', border: 'none', width: '100%', color: '#ffffff'}}>
                <GiKnifeFork color='#ffffff'/> Nutrition
              </Button>
            </Col>
          </Row>
          <br/>
          <Row>
            <Col>
              <Button onClick={() => this.ChangeRender('programs')} style={{textAlign: 'left', backgroundColor: 'inherit', color: 'inherit', border: 'none', width: '100%', color: '#ffffff'}}>
                <FaCalendarAlt color='#ffffff'/> Programs
              </Button>
            </Col>
          </Row>
          <br/>
          <Row>
            <Col>
              <Button onClick={() => this.ChangeRender('packages')} style={{textAlign: 'left', backgroundColor: 'inherit', color: 'inherit', border: 'none', width: '100%', color: '#ffffff'}}>
                <BiPackage color='#ffffff'/> Packages
              </Button>
            </Col>
          </Row>
          <br/>
          <Row>
            <Col>
              <Button onClick={() => this.ChangeRender('trainers')} style={{textAlign: 'left', backgroundColor: 'inherit', color: 'inherit', border: 'none', width: '100%', color: '#ffffff'}}>
                <IoMdPeople color='#ffffff'/> Trainers
              </Button>
            </Col>
          </Row>
          <br/>
          <Row>
            <Col>
              <Button onClick={() => this.ChangeRender('scheduler')} style={{textAlign: 'left', backgroundColor: 'inherit', color: 'inherit', border: 'none', width: '100%', color: '#ffffff'}}>
                <BiTimeFive color='#ffffff'/> Scheduler
              </Button>
            </Col>
          </Row>
          <br/>
          <Row>
            <Col>
              <Button onClick={() => this.ChangeRender('calendar')} style={{textAlign: 'left', backgroundColor: 'inherit', color: 'inherit', border: 'none', width: '100%', color: '#ffffff'}}>
                <AiFillCalendar color='#ffffff'/> Calendar
              </Button>
            </Col>
          </Row>
        </>
      }

      this.ToggleMenuCollapse = () => {
        this.setState({menu_collapsed: !this.state.menu_collapsed})
      }

      this.CollapseSelection = () => {
        var menu_collapsed = this.state.menu_collapsed

        if (menu_collapsed == true){
          return<Row>
            <Col>
              <Button onClick={this.ToggleMenuCollapse} style={{textAlign: 'left', backgroundColor: 'inherit', color: 'inherit', border: 'none', width: '100%', color: '#ffffff'}}>
                SHOW DASHBOARD MENU
              </Button>
            </Col>
          </Row>
        }else{
          return<Row>
            <Col>
              <Button onClick={this.ToggleMenuCollapse} style={{textAlign: 'left', backgroundColor: 'inherit', color: 'inherit', border: 'none', width: '100%', color: '#ffffff'}}>
                HIDE DASHBOARD MENU
              </Button>
            </Col>
          </Row>
        }
      }

      this.DashboardMenu = () => {
        var on_mobile = this.state.on_mobile
        var menu_collapsed = this.state.menu_collapsed

        if ((on_mobile == true) && (menu_collapsed == true)) {
          return<>
            <this.CollapseSelection/>
          </>
        }else if ((on_mobile == true) && (menu_collapsed == false)){
          return<>
            <this.CollapseSelection/>
            <this.DashboardSelections/>
          </>
        }else{
          return <this.DashboardSelections/>
        }
      }
    }

    componentDidMount() {
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        this.setState({
          on_mobile: true
        })
      }
      const { cookies } = this.props;
      if(cookies.get('token')==null){
        let port = (window.location.port ? ':' + window.location.port : '');
        window.location.href = '//' + window.location.hostname + port + '/signin';
      };

      var redirect = this.props.match.params.redirect
      if (redirect == 'program_purchase'){
        this.setState({current_render: 'clients'})
      }else if(redirect == 'session_booked'){
        this.setState({current_render: 'clients'})
      }else if(redirect == 'message'){
        this.setState({current_render: 'messages'})
      }

      axios.get(Backend_Url + 'getUserDetailsByAccessToken/' + cookies.get('token'))
      .then(res => {
        this.setState({
          user_details: res.data
        });
      })
      .catch((error) => {
        console.log(error);
      });

      var data = new FormData()
      data.append('user_access_token', cookies.get('token'))

      axios.post(Backend_Url + 'allClients', data)
      .then((res) => {
          let result = res.data
            this.setState({all_clients: result})
      }).catch((error) => {
          console.log(error)
      })
    }




    render() {
      var user_details = this.state.user_details

      if(user_details.role == 'user'){
        return<UserDashboard user_details={user_details} redirect={this.props.match.params.redirect} />
      }

      return (
        <div style={{minHeight: '550px', backgroundColor: '#E0DBDF'}}>
            <Helmet>
              <title>TRAINER DASHBOARD - ONFIT</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <Row style={{minHeight: '600px', margin: '0px', backgroundImage: "url(" + Background_Image + ")"}}>
                <Col sm='2' style={{backgroundColor: '#1faced'}}>
                  <this.DashboardMenu/>
                </Col>
                <Col>
                  <this.RenderSelection/>
                </Col>
            </Row>
        </div>
      );
    }

  };
  
  export default withCookies(Dashboard);